export enum WebSocketEventTypes {
  LOGIN_TIMEOUT = 'LOGIN_TIMEOUT',
  CLOSED = 'CONNECTION_CLOSED',
  ERROR = 'ERROR',
  UNKNOWN_RESPONSE = 'UNKNOWN_WEBSOCKET_RESPONSE',
  PARSED_RESPONSE = 'PARSED_WEBSOCKET_RESPONSE',
}

export type WebSocketEventData<T> = {
  data?: T;
  key: string;
  eventType: WebSocketEventTypes;
};
